import React from 'react';
import { Link } from 'react-router-dom';
import { SessionListSessionTypePill } from '../Pills';
import { formatDate, prettyPrintMsTime } from '../../util';
import './styles.scss';

type Session = {
  id: string;
  timestamp: string;
  type: string;
  totalPlaytimeInMs: number;
  activities: any
}

type UserSessionsTableProps = {
  sessions: Session[];
};

const UserSessionsTable = ({ sessions = [] }: UserSessionsTableProps) => (
  <div className="user-sessions-table-wrapper">
    <table className="user-sessions-table">
      <thead>
      <tr>
        <th>Session ID</th>
        <th>Start Time</th>
        <th>Total Play Time</th>
        <th>Type</th>
      </tr>
      </thead>

      <tbody>
      {
        sessions.map((session, index) => (
          <tr key={index}>
            <td><Link to={`/sessions/${session.id}`}>{session.id}</Link></td>
            <td>
              {
                session?.timestamp &&
                formatDate(new Date(session?.timestamp), null, true)
              }
            </td>
            <td>
              {
                prettyPrintMsTime(session?.totalPlaytimeInMs)
              }
            </td>
            <td>
              <SessionListSessionTypePill type={session?.type}>
                {session?.type}
              </SessionListSessionTypePill>
            </td>
          </tr>
        ))
      }
      </tbody>
    </table>
  </div>
);

export default UserSessionsTable;
